import React, { useState } from 'react';
import './iconTips.scss';

export function IconTips(label: string) {
    const [showTips, handlerShowTips] = useState(false);
    return (
        <i
            className="icon-tips"
            onMouseEnter={() => {
                handlerShowTips(true);
            }}
            onMouseLeave={() => {
                handlerShowTips(false);
            }}
        >
            {showTips ? <div className="label-content">{label}</div> : null}
        </i>
    );
}
